import { DataZone } from 'src/app/models/data-zone/data-zone';

export enum DeploymentSubscription {
  DEVELOPMENT = 'nonpii',
  TEST = 'nonpii',
  PII = 'pii',
  PROD = 'prod'
}

export const deploymentSubscriptions = Object.values<DeploymentSubscription>(DeploymentSubscription);

export function dataZoneToDeploymentSubscription(dataZone: DataZone): DeploymentSubscription {
  return dataZone === DataZone.DEVELOPMENT ? DeploymentSubscription.TEST :
    dataZone === DataZone.SECURE ? DeploymentSubscription.PII : DeploymentSubscription.PROD;
}
